import { useQuery } from 'react-query'

import { useUmbrella } from '@modules-deprecated/app/umbrellas'
import { fetchUmbrellaUserInvitations } from '@modules-deprecated/app/umbrellas/query-api'
import { InvitedUmbrellaUser } from '@modules-deprecated/app/umbrellas/types/invitedUmbrellaUser'

import { QueryKeys } from '../../../../../enums/queryKeys'

interface UseInvitedUsersResponse {
  data: InvitedUmbrellaUser[]
  isLoading: boolean
}

export const useInvitedUsers = (): UseInvitedUsersResponse => {
  const { umbrella } = useUmbrella()
  const umbrellaId = umbrella?.id || ''

  const {
    data: invitedUsersData,
    isIdle,
    isLoading,
  } = useQuery([QueryKeys.UmbrellaInvitedUsers], () => fetchUmbrellaUserInvitations(umbrellaId), {
    enabled: !!umbrellaId,
  })

  return {
    data: invitedUsersData?.data || [],
    isLoading: isIdle || isLoading,
  }
}
